import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"
import spriteSheetImage from "../media/other/PlayerSpriteSheet.png"

const snippet = `
    this.cloudsBig.tilePositionX += 0.15;
    this.cloudsSmall.tilePositionX += 0.35;
    this.mountains.tilePositionX += 0.1;
    this.hills.tilePositionX += 0.25;
    this.ground.tilePositionX += 0.45;
`
const loadPlayerSnippet = `
    this.load.spritesheet("player", "PlayerSpriteSheet.png", {
      frameWidth: 266,
      frameHeight: 122
    });
`

const animationSnippet = `
    // Create Player Animation
    var playerAnimConfig = {
      key: "playerAnimation",
      frames: this.anims.generateFrameNumbers("player", {
        start: 0,
        end: 2,
        first: 0
      }),
      frameRate: 10,
      repeat: -1
    };

      this.anims.create(playerAnimConfig);

          this.player = this.physics.add
      .sprite(250, 250, "player")
      .play("playerAnimation");
          this.player.setScale(0.4);
    this.player.setCollideWorldBounds(true);
`

const Animation = () => (
  <>
    <h1>Animation</h1>
    <p>
      Right now our scene is pretty boring, so lets get things moving. Inside
      the update function paste the following code and hit start. You should see
      the scene moving now.
    </p>
    <CopyBlock
      text={snippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Since we created these sprites as tile sprites they keep redrawing and
      will move on forever. You can mess with the numbers to see the layers move
      faster or slower. What we are telling phaser is every time the update
      method is called move the image slighly.
    </p>
    <h2>Sprite Sheets</h2>
    <img alt="Layout image" src={spriteSheetImage} width={800} height={200} />
    <p>
      Sprite sheet can contain a bunch of images in one sheet, we are using a
      sprite sheet specifically for the player. Each picture represents a
      different part of an animation of the plane flying. Using each of these
      images we can tell Phaser to create an animation. But first we need to a
      new variable for the player. Underneath the other variable add a new
      "player" variable like this:
    </p>
    <CopyBlock
      text={`player;`}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Next in the preload function we need to tell Phaser what the name of our
      sprite sheet is named so add the following:{" "}
    </p>
    <CopyBlock
      text={loadPlayerSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now that Phaser knows where our sprite sheet is lets setup the animation.
      Inside the create function add the following:
    </p>
    <CopyBlock
      text={animationSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <br />
    <br />
    <Button type="button" variant="secondary" href="/PlayerInput">
      Next
    </Button>
    <br />
    <br />
  </>
)

export default Animation
